import axios from "axios";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach JWT token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ypk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const resolveFileUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
